export class PaginationDataModel {
  currentPage!: number;
  pageSize!: number;
  totalElements!: number;
  totalPages!: number;
}
